export const isIAOrPCOrder = (order) =>
  order.requested_pathology_consultation || order.requested_image_analysis;
